<template>
  <div class="login max-content">
    <!-- <div class="top-pic">
      <img
        src="https://cdn.edstatic.com/203012120000/de1399d5fde734529040f0229dbb96d2/2026/02/5228a344-c363-45ad-8282-7b6e92107bb4.png"
        alt="">
    </div> -->
    <div class="tabs">
      <div :class="tabValue == 1 ? 'active' : ''" @click="switchTab(1)">手机登录</div>
      <div :class="tabValue == 2 ? 'active' : ''" @click="switchTab(2)">邮箱登录</div>
    </div>
    <!-- 手机号登录 -->
    <div class="login-form" v-if="tabValue == 1">
      <van-cell-group :border="false">
        <div class="left-flag" @click="showPicker = true">
          <img :src="flag_src" alt="" />
          <span>{{ "+" + area_code }}</span>
          <van-icon name="arrow-down" />
        </div>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
        </van-popup>
        <van-field v-model="formData.mobile" placeholder="手机号" clearable :border="false" />
      </van-cell-group>
      <van-cell-group :border="false">
        <van-field v-model="formData.img_code" placeholder="图形验证码" clearable :border="false" />
        <img :src="image_code" @click="changeImgCode" />
      </van-cell-group>
      <van-cell-group :border="false">
        <van-field v-model="formData.code" placeholder="短信验证码" clearable :border="false" />
        <div @click="sendCode" class="code" :style="{ 'color': countdown < 60 ? '#901D22' : '' }">{{
          sendTimeText
        }}</div>
      </van-cell-group>
      <div v-if="showTips" class="tips">{{ tipText }}</div>
      <button @click="Login" class="login-button" :disabled="disabled"
        :class="formData.mobile && formData.img_code && formData.code ? '' : 'grey'">登录</button>
    </div>
    <!-- 邮箱登录 -->
    <div class="login-form" v-if="tabValue == 2">
      <van-cell-group :border="false">
        <van-field v-model="formData2.email" placeholder="邮箱" clearable :border="false" />
      </van-cell-group>
      <van-cell-group :border="false">
        <van-field v-model="formData2.img_code" placeholder="图形验证码" clearable :border="false" />
        <img :src="image_code" @click="changeImgCode" />
      </van-cell-group>
      <van-cell-group :border="false">
        <van-field v-model="formData2.code" placeholder="验证码" clearable :border="false" />
        <div @click="sendEmailCode" class="code" :style="{ 'color': countdown < 60 ? '#901D22' : '' }">{{
          sendTimeText
        }}</div>
      </van-cell-group>
      <div v-if="showTips" class="tips">{{ tipText }}</div>
      <!-- <div class="tips" style="color: #999999;" v-if="emailSendStatus">没有收到验证码？<span
          style="color: #204FA2;" @click="sendEmailCode">点击重新发送</span> </div> -->
      <button @click="emailLogin" class="login-button" :disabled="disabled"
        :class="formData2.email && formData2.img_code && formData2.code ? '' : 'grey'">登录</button>
    </div>
  </div>
</template>
<script>
import {
  SendCode,
  SendEmailCode,
  EmailLogin,
  GetUserInfo,
  VascularLogin,
  BindMobile,
  BindEmail,
  countryPhoneCode,
  imgCode
} from "../../../config/interface.js";
import { CountDown, Dialog, Toast } from "vant";

let codeTimer;
export default {
  data() {
    return {
      sendTimeText: "发送验证码",
      sendTimeText2: "发送验证码",
      tabValue: 1,
      tipText: '',
      emailSendStatus: false,
      showTips: false,
      formData: {
        mobile: "",
        code: "",
        img_code: ''
      },
      formData2: {
        email: "",
        code: "",
        img_code: ''
      },
      img_url: '',
      image_code: '',
      countdown: 60,
      isReSend: true, //能否再次点击发送验证码
      isBind: true,
      showPicker: false,
      disabled: false,
      area_code: '86',
      flag_src: require('../../../assets/images/System/flag/China.png'),
      timestamp: '',
      columns: [
        '中国',
        '中国香港',
        '中国澳门',
        '中国台湾',
        '新加坡',
        '英国',
        '美国',
        '加拿大',
        '希腊',
        '荷兰',
        '比利时',
        '法国',
        '西班牙',
        '爱尔兰',
        '瑞士',
        '德国'
      ],
      codes: {},
      flags: {
        '中国': require('../../../assets/images/System/flag/China.png'),
        '中国香港': require('../../../assets/images/System/flag/China.png'),
        '中国澳门': require('../../../assets/images/System/flag/China.png'),
        '中国台湾': require('../../../assets/images/System/flag/China.png'),
        '新加坡': require('../../../assets/images/System/flag/Singapore.png'),
        '英国': require('../../../assets/images/System/flag/UK.png'),
        '美国': require('../../../assets/images/System/flag/USA.png'),
        '加拿大': require('../../../assets/images/System/flag/Canada.png'),
        '希腊': require('../../../assets/images/System/flag/Greece.png'),
        '荷兰': require('../../../assets/images/System/flag/Holland.png'),
        '比利时': require('../../../assets/images/System/flag/Belgium.png'),
        '法国': require('../../../assets/images/System/flag/France.png'),
        '西班牙': require('../../../assets/images/System/flag/Spain.png'),
        '爱尔兰': require('../../../assets/images/System/flag/Ireland.png'),
        '瑞士': require('../../../assets/images/System/flag/Swit.png'),
        '德国': require('../../../assets/images/System/flag/Germany.png'),
      }
    };
  },
  created() {

  },
  mounted() {
    if (common.is_weixin) {
      this.getPersonalUserInfo(); //微信登录需要授权 所以要获取用户信息判断是否授权
    }
    this.getImgCode()
    this.getCountryCode();

  },
  methods: {
    //区号
    getCountryCode() {
      const url = countryPhoneCode;
      const method = "POST";
      fetch(url, {}, method).then((res) => {
        if (res.code == 0) {
          let data = res.data;
          data.forEach(element => {
            this.codes[element.country_cn] = element.code;
          });

        }
      });

    },
    getImgCode() {
      const url = imgCode;
      const method = "GET";
      fetch(url, {}, method).then((res) => {
        if (res.code == 0) {
          console.log(res.data.base64_image)
          this.image_code = res.data.base64_image
        }
      });
    },
    //
    Login() {
      if (this.isBind == false) {
        Dialog.confirm({
          message: "确定将该微信绑定该手机号？",
        })
          .then(() => {
            if (this.verifyForm()) {
              Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '',
              });
              this.disabled = true;
              const url = BindMobile;
              const method = "POST";
              let params = {
                mobile: this.formData.mobile,
                msgcode: this.formData.code,
                code: this.formData.img_code,
                country_code: this.area_code
              };
              fetch(url, params, method).then((res) => {
                this.disabled = false;
                Toast.clear();
                if (res.code == 0) {
                  common.toast("登录成功", 1000, "success", () => {
                    localStorage.setItem("token", res.data.user_access_token);
                    this.setUserInfo(res.data.local_data);
                  });
                } else {
                  if (res.code == 901) {
                    Dialog.confirm({
                      message: "您的账号已在PC端注册过，是否强制合并账号？",
                    })
                      .then(() => {
                        Toast.loading({
                          duration: 0,
                          forbidClick: true,
                          message: '',
                        });
                        this.disabled = true;
                        const url = BindMobile;
                        const method = "POST";
                        let params = {
                          mobile: this.formData.mobile,
                          msgcode: this.formData.code,
                          code: this.formData.img_code,
                          country_code: this.area_code,
                          merge_account: 1,
                        };
                        fetch(url, params, method).then((res) => {
                          this.disabled = false;
                          Toast.clear();
                          if (res.code == 0) {
                            common.toast("登录成功", 1000, "success", () => {
                              localStorage.setItem("token", res.data.user_access_token);
                              this.setUserInfo(res.data.local_data);
                            });
                          } else {
                            common.toast(res && res.error_msg ? res.error_msg : "未知错误", 1000, 'fail', () => {
                            })
                          }
                        });
                      })
                      .catch(() => { });
                  } else {
                    common.toast(
                      res && res.error_msg ? res.error_msg : "未知错误",
                      1000,
                      "fail",
                      () => { }
                    );
                  }
                }
              });
            }
          })
          .catch(() => { });
      } else {
        if (this.verifyForm()) {
          Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '',
          });
          this.showTips = false;
          this.tipText = ''
          this.disabled = true;
          const url = VascularLogin;
          const method = "POST";
          let params = {
            mobile: this.formData.mobile,
            country_code: this.area_code,
            msgcode: this.formData.code,
            code: this.formData.img_code,
          };
          fetch(url, params, method).then((res) => {
            this.disabled = false;
            Toast.clear();
            if (res.code == 0) {
              common.toast("登录成功", 1000, "success", () => {
                localStorage.setItem("token", res.data.user_access_token);
                this.setUserInfo(res.data.local_data);
              });
            } else {
              common.toast(res && res.error_msg ? res.error_msg : "未知错误", 1000, 'fail', () => { })
            }
          });
        }
      }
    },
    //验证手机号
    verifyMobile() {
      let mobile = this.formData.mobile;
      let reg = /^1[3456789]\d{9}$/
      if (mobile == "") {
        this.showTips = true;
        this.tipText = "请输入手机号";
      } else if (!reg.test(mobile) && this.area_code == '86') {
        this.showTips = true;
        this.tipText = "手机号输入错误，请重新输入";
      } else if (this.formData.img_code == '') {
        this.showTips = true;
        this.tipText = "请输入图形验证码";
      } else {
        return true;
      }
      return false;
    },
    //验证邮箱
    verifyEmail() {
      let email = this.formData2.email;
      let reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      if (email == "") {
        this.showTips = true;
        this.tipText = "请输入邮箱";
      } else if (!reg.test(email)) {
        this.showTips = true;
        this.tipText = "邮箱输入错误，请重新输入";
      } else if (this.formData2.img_code == '') {
        this.showTips = true;
        this.tipText = "请输入图形验证码";
      } else {
        return true;
      }
    },
    //区号选择
    onConfirm(value) {
      this.area_code = this.codes[value];
      this.flag_src = this.flags[value];
      this.showPicker = false;
    },
    //点击发送验证码
    sendCode() {
      if (this.isReSend && this.verifyMobile()) {
        this.showTips = false;
        this.tipText = ''
        this.getCode();
        this.isReSend = false;
      }
    },
    //点击发送邮箱验证码
    sendEmailCode() {
      if (this.verifyEmail() && this.formData2.img_code != '') {
        this.showTips = false;
        this.tipText = ''
        this.getEmailCode();
        this.isReSend = false;
      }
    },
    //获取邮箱验证码
    getEmailCode() {
      const url = SendEmailCode;
      let params = {
        email: this.formData2.email,
        code: this.formData2.img_code
      };
      const method = "POST";
      fetch(url, params, method).then((res) => {
        if (res.code == 0) {
          this.sendTime();
          // this.emailSendStatus = true;
          // this.sendTimeText2 = '已发送'
        } else {
          this.showTips = true;
          this.tipText = res.error_msg;
        }
      });
    },
    //邮箱登录
    emailLogin() {
      if (this.isBind == false) {
        Dialog.confirm({
          message: "确定将该微信绑定该邮箱？",
        })
          .then(() => {
            if (this.verifyEmail()) {
              Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '',
              });
              this.disabled = true;
              const url = BindEmail;
              const method = "POST";
              let params = {
                email: this.formData2.email,
                msgcode: this.formData2.code,
                code: this.formData2.img_code,
              };
              fetch(url, params, method).then((res) => {
                this.disabled = false;
                Toast.clear();
                if (res.code == 0) {
                  common.toast("登录成功", 1000, "success", () => {
                    localStorage.setItem("token", res.data.user_access_token);
                    this.setUserInfo(res.data.local_data);
                  });
                } else {
                  if (res.code == 901) {
                    Dialog.confirm({
                      message: "您的账号已在PC端注册过，是否强制合并账号？",
                    })
                      .then(() => {
                        Toast.loading({
                          duration: 0,
                          forbidClick: true,
                          message: '',
                        });
                        this.disabled = true;
                        const url = BindEmail;
                        const method = "POST";
                        let params = {
                          email: this.formData2.email,
                          msgcode: this.formData2.code,
                          code: this.formData2.img_code,
                          merge_account: 1,
                        };
                        fetch(url, params, method).then((res) => {
                          this.disabled = false;
                          Toast.clear();
                          if (res.code == 0) {
                            common.toast("登录成功", 1000, "success", () => {
                              localStorage.setItem("token", res.data.user_access_token);
                              this.setUserInfo(res.data.local_data);
                            });
                          } else {
                            common.toast(res && res.error_msg ? res.error_msg : "未知错误", 1000, 'fail', () => {
                            })
                          }
                        });
                      })
                      .catch(() => { });
                  } else {
                    common.toast(
                      res && res.error_msg ? res.error_msg : "未知错误",
                      1000,
                      "fail",
                      () => { }
                    );
                  }
                }
              });
            }
          })
          .catch(() => { });
      } else {
        this.disabled = true;
        const url = EmailLogin;
        if (!this.verifyEmail()) { return false; }
        let params = {
          email: this.formData2.email,
          msgcode: this.formData2.code
        };
        const method = "POST";
        fetch(url, params, method).then((res) => {
          if (res.code == 0) {
            this.disabled = false;
            Toast.clear();
            if (res.code == 0) {
              common.toast("登录成功", 1000, "success", () => {
                localStorage.setItem("token", res.data.user_access_token);
                this.setUserInfo(res.data.local_data);
              });
            } else {
              common.toast(res && res.error_msg ? res.error_msg : "未知错误", 1000, 'fail', () => { })
            }
          }
        });
      }
    },
    //看是否绑定手机号
    getPersonalUserInfo() {
      if (common.is_weixin()) {
        //微信端页面
        const url = GetUserInfo;
        let params = {};
        const method = "POST";
        fetch(url, params, method).then((res) => {
          if (res.code == 0) {
            let data = res.data;
            this.userInfo = JSON.stringify(data);
            localStorage.setItem("userInfo", JSON.stringify(data));
            this.$store.dispatch("storageUserInfo", data);
            if (data.mobile_status == 0) {
              this.isBind = false;
            }
          }
        });
      }
    },
    //得到验证码
    getCode(mobile) {
      this.sendTime();
      const url = SendCode;
      const method = "POST";
      let params = {
        mobile: this.formData.mobile,
        country_code: this.area_code,
        code: this.formData.img_code
      };
      fetch(url, params, method).then((res) => {
        if (res.code == 0) {

        } else {
          console.log("注册");
        }
      });
    },
    switchTab(val) {
      this.tabValue = val;
      this.showTips = false;
      this.tipText = ''
      this.sendTimeText2 = '发送验证码';
      this.emailSendStatus = false;
      this.getImgCode()
      this.formData = {
        mobile: '',
        code: '',
        img_code: ''

      }
      this.formData2 = {
        email: '',
        code: '',
        img_code: ''

      }
    },
    changeImgCode() {
      this.getImgCode()
    },
    sendTime() {
      codeTimer = setTimeout(() => {
        if (this.countdown == 1) {
          this.clearCodeTimer();
          return;
        } else {
          this.countdown--;
          this.sendTimeText = this.countdown + "s";
          setTimeout(this.sendTime(), 1000);
        }
      }, 1000);
    },
    //清除定时器
    clearCodeTimer() {
      clearTimeout(codeTimer);
      this.isReSend = true;
      this.sendTimeText = "获取验证码";
      this.countdown = 60;
    },
    //验证表单
    verifyForm() {
      if (!this.verifyMobile()) {
      } else if (this.formData.code == "") {
        common.toast("请输入验证码", 1000);
      } else if (this.formData.img_code == '') {
        return false;
      } else {
        return true
      }
      return false;
    },
    setUserInfo(data) {
      localStorage.setItem("userInfo", JSON.stringify(data));
      this.$store.dispatch("storageUserInfo", data);
      let url = this.$route.query.url ? this.$route.query.url : null;
      // let id=this.$route.query.id? this.$route.query.id :null;
      // let meeting_id=this.$route.query.meeting_id? this.$route.query.meeting_id :null;
      // let chapter_id=this.$route.query.chapter_id? this.$route.query.chapter_id :null;
      // let channel_id=this.$route.query.channel_id? this.$route.query.channel_id :null;
      // if(id){
      //   url=url+'&id='+id;
      // }
      // if(meeting_id){
      //   url=url+'&meeting_id='+meeting_id;
      // }
      // if(chapter_id){
      //   url=url+'&chapter_id='+chapter_id;
      // }
      // if(channel_id){
      //   url=url+'&channel_id='+channel_id;
      // }
      if (url) {
        window.location.replace(url);
      } else {
        this.$router.replace({
          path: "/vascularNews",
        });
      }
    },
    //获取用户信息
    getUserInfo() {
      const url = GetUserInfo;
      const method = "POST";
      let params = {};
      fetch(url, params, method)
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            localStorage.setItem("userInfo", JSON.stringify(data));
            this.$store.dispatch("storageUserInfo", data);
            let url = this.$route.query.url ? this.$route.query.url : null;
            if (url) {
              window.location.replace(url);
            } else {
              this.$router.replace({
                path: "/vascularNews",
              });
            }
          }
        })
        .catch(() => { });
    },
  },
  destroyed() {
    this.clearCodeTimer();
  },
};
</script>
<style lang="scss">
.login {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #FDE4E5 0%, #FCF7F7 24%);
  padding-top: 150px;

  .top-pic {
    width: 50%;
    padding: 40px 0;
    margin: 0 auto;
    text-align: center;


    img {
      width: 100%;
    }
  }

  .tabs {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    gap: 60px;

    div {
      font-size: 16px;
      position: relative;
      color: #666666;
      z-index: 2;
    }

    .active {
      color: #000000;

      &::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: -4px;
        transform: translate(-50%, -50%);
        width: 66px;
        height: 10px;
        background: #FCE5E6;
        z-index: -1;
      }
    }
  }

  .header {
    padding-top: 100px;
    text-align: center;
    font-size: 18px;
    line-height: 20px;

    img {
      display: block;
      margin: -20px auto 20px;
    }
  }

  .login-form {
    width: 90%;
    margin: 0 auto;
    padding: 30px 0;
    border-radius: 15px;
    background: #ffffff;

    .van-cell-group {
      width: 310px;
      height: 40px;
      box-sizing: border-box;
      margin: 0 auto;
      margin-bottom: 15px;
      @include flex(row);
      align-items: center;
      // border-bottom: 1px solid #d3d3d3;
      padding-left: 15px;
      padding-right: 5px;
      border-radius: 10px;
      background: #f6f6f6;

      .van-cell {
        padding: 0px 10px;
        background: transparent;

        input {
          height: 40px;
          outline: none;
          font-size: 12px;
        }

        input::-webkit-input-placeholder {
          color: #999999;
          // font-size: 14px;
        }
      }

      img {
        height: 20px;
        vertical-align: middle;
      }

      .left-flag {
        line-height: 25px;
        width: 120px;
        display: flex;
        align-items: center;
      }
    }

    .code {
      width: 110px;
      color: #999999;
      text-align: center;
    }

    .login-button {
      display: block;
      margin: 30px auto;
      width: 310px;
      height: 44px;
      background: #901d22;
      font-size: 17px;
      color: #fff;
      border: 0px;
      border-radius: 10px;
    }
  }
}

.tips {
  width: 310px;
  margin: 0 auto;
  padding: 0 10px;
  color: #901d22;
}

.grey {
  opacity: 0.5;
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/User/Login.vue